<template>
  <view :style="{ height: navBar.height + navBar.top + 8 + 'px' }" v-if="navBar.height > 0">
    <view
      class="header"
      :style="{
        background: background,
        'padding-top': navBar.top + 'px',
        'line-height': navBar.height + 'px',
      }"
    >
      <view class="left" :style="{ color: color }" v-if="backBtn || title" @click="handleBack">
        <wd-icon name="thin-arrow-left" size="14px" :color="color" v-if="backBtn"></wd-icon>
        <view class="title">{{ title }}</view>
      </view>
      <view class="flex1">
        <slot></slot>
      </view>
    </view>
  </view>
</template>

<script>
export default {
  name: 'NavBar',
  data() {
    return {
      navBar: {
        top: 0,
        height: 0,
      },
    }
  },
  props: {
    background: {
      type: String,
      default: '#fff',
    },
    color: {
      type: String,
      default: '#333',
    },
    title: {
      type: String,
      default: '',
    },
    backBtn: {
      type: Boolean,
      default: true,
    },
    isBackHome: {
      type: Boolean,
      default: false,
    },
    isBackIndex: {
      type: Boolean,
      default: false,
    },
    isBackOrder: {
      type: Boolean,
      default: false,
    },
    isShow: {
      type: Boolean,
      default: false,
    },
  },
  mounted() {
    //#ifdef APP-PLUS
    this.navBar.top = uni.getSystemInfoSync()['statusBarHeight']
    this.navBar.height = 40
    // #endif
    //#ifdef MP
    this.navBar = uni.getMenuButtonBoundingClientRect()
    // #endif
    // #ifdef H5
    if (this.isShow) {
      this.navBar.top = 0
      this.navBar.height = 40
    } else {
      this.navBar.top = 0
      this.navBar.height = 0
    }
    // #endif
  },
  methods: {
    handleBack: function () {
      // 触发自定义事件，优先使用外部传入的处理函数
      const hasBackListeners = this.$listeners && this.$listeners.back
      if (hasBackListeners) {
        this.$emit('back')
      } else {
        // 如果没有监听器，执行默认返回逻辑
        this.back()
      }
    },
    back: function () {
      if (this.isBackIndex) {
        uni.redirectTo({
          url: '/taxi/index',
        })
        return false
      }
      if (this.isBackHome) {
        uni.switchTab({
          url: '/pages/index/index',
        })
        return false
      }
      if (this.isBackOrder) {
        uni.switchTab({
          url: '/pages/order/index',
        })
        return false
      }
      if (getCurrentPages().length <= 1) {
        uni.switchTab({
          url: '/pages/index/index',
        })
        return false
      } else {
        uni.navigateBack({
          delta: 1,
        })
      }
    },
  },
}
</script>
<style lang="scss" scoped>
.header {
  position: fixed;
  top: 0;
  right: 0;
  left: 0;
  z-index: 999;
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding-top: var(--status-bar-height);
  box-sizing: border-box;
  width: 100%;
  // #ifdef MP
  padding-right: 190rpx;
  // #endif
  // #ifdef H5 || APP-PLUS
  padding-right: 32rpx;
  // #endif

  .left {
    display: flex;
    align-items: center;
    padding: 0 32rpx;
    height: 100%;
    transition: opacity 0.2s ease;

    &:active {
      opacity: 0.7;
    }

    .title {
      margin-left: 16rpx;
      font-size: 32rpx;
      font-weight: 500;
      color: inherit;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      max-width: 400rpx;
    }
  }
}

.flex1 {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  padding-right: 24rpx;
}
</style>
